import { ThirdPartyPackageConfig } from "stores/wizard/config";

export const thirdPartyPackageConfig: ThirdPartyPackageConfig = {
  navigation: {
    tabIcon: "lob_all_inclusive_vacations",
    tabTitleToken: "wizard.thirdPartyPackage.tab.title.label"
  }
};
